"use client"
import { type NumberFormatOptions, useNumberFormatter } from "@opensea/i18n"
import type { BigNumberLike } from "@opensea/utils"
import type React from "react"
import type { ComponentPropsWithoutRef } from "react"
import { classNames } from "../../utils/classNames"

export type NumberProps = {
  className?: string
  value?: BigNumberLike | null | undefined
  children?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
} & NumberFormatOptions &
  ComponentPropsWithoutRef<"span">

export function NumberDisplay({
  value,
  children,
  className,
  bounded,
  display,
  suffix,
  prefix,
  custom,
  compactionThreshold,
  ref,
  ...rest
}: NumberProps) {
  const format = useNumberFormatter()
  return (
    <span className={classNames("font-mono", className)} {...rest} ref={ref}>
      {children ??
        format(value, {
          bounded,
          display,
          suffix,
          prefix,
          custom,
          compactionThreshold,
        })}
    </span>
  )
}
